var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgContacts = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#5f6368",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M174.24-65.41q-16.48 0-29.96-13.48t-13.48-29.96v-109.06q0-93.11 58.01-164.74 58.01-71.63 149.17-91.35-41.48 29.07-64.3 73.19-22.81 44.11-22.81 94.94v197.09q0 11.41 3.24 22.65 3.24 11.24 10.48 20.72h-90.35Zm152.41 0q-17.63 0-30.49-12.86t-12.86-30.49v-197.03q0-72.59 51.18-123.4Q385.65-480 458.24-480h195.99q72.58 0 123.39 50.78 50.82 50.79 50.82 123.34v66.33q0 72.55-50.81 123.34-50.8 50.8-123.37 50.8H326.65Zm153.23-501.7q-68.27 0-115.95-47.79-47.67-47.8-47.67-115.95t47.79-115.94q47.8-47.8 116.07-47.8t115.95 47.8q47.67 47.79 47.67 115.94T595.95-614.9q-47.8 47.79-116.07 47.79Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgContacts, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/contacts.d25ef365.svg";
export { ForwardRef as ReactComponent };